/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Box, Button, Typography, Link, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from "@mui/material";
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloseIcon from "@mui/icons-material/Close";
import Style from "../../Styles/CssModulesGlobal.module.scss";
import { isEmpty } from '../../../utils/constants';

const getPopUpIcon = (PopUpIcon) => {
    if (PopUpIcon === "clockIcon") {
        return <AccessTimeRoundedIcon sx={{ fontSize: "90px", color: "#44A4EB" }} />
    } else if (PopUpIcon === "infoIcon") {
        return <InfoOutlinedIcon sx={{ fontSize: "90px", color: "#44A4EB" }} />
    } else if (PopUpIcon === "delete") {
        return <DeleteForeverOutlinedIcon sx={{ fontSize: "90px", color: "#44A4EB" }} />
    } else if (PopUpIcon === "warning") {
        return <WarningAmberIcon sx={{ fontSize: "85px", color: "#ff0000" }} />
    } else {
        return <CheckCircleOutlineRoundedIcon sx={{ fontSize: "90px", color: "#44A4EB" }} />
    }
}

export default function CustomDialogPopUp(props) {

    const { openPopup, togglePopUp, handleSubmit, handlecancel = false, showInputBox = false, allStrings = {}, 
    showCloseBtn = true, PopUpIcon = false, size="sm", showPopUpIcon = true, bottomLinkAction = false, customElement = false } = props;
    
    const [textFieldValue, setTextFieldValue] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue.length > 100) {
            setErrorMessage('Maximum characters exceeded (100)');
        } else {
            setErrorMessage('');
        }
        setTextFieldValue(inputValue);
    };

    return (
        <Dialog
            open={openPopup}
            // onClose={() => { togglePopUp() }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={size}
        >
            {showCloseBtn && (
                <IconButton aria-label="close" className={Style.closeDialog} sx={{ top: !showPopUpIcon ? "5px" : "" }} onClick={() => { togglePopUp() }}>
                    <CloseIcon />
                </IconButton>
            )}

            <DialogContent sx={{ textAlign: "center" }}>
                
                { showPopUpIcon && getPopUpIcon(PopUpIcon)}
                <DialogTitle
                    sx={{ fontSize: "32px", fontWeight: "600", pt: 0 }}
                    id="alert-dialog-title"
                >
                    {allStrings?.TITLE}
                </DialogTitle>
                <DialogContentText
                    sx={{ fontSize: "16px", fontWeight: "500", color: "#333", mb: 3 }}
                    id="alert-dialog-description"
                >
                    {customElement}
                    {allStrings?.BODY}
                </DialogContentText>
                <DialogContentText
                    sx={{ fontSize: "16px", fontWeight: "600", color: "#333", mb: 3 }}
                    id="alert-dialog-description"
                >
                    {showInputBox && (
                        <>
                            <TextField
                                name=""
                                type="text"
                                multiline
                                onChange={handleInputChange}
                                // onChange={(e) => { setTextFieldValue(e.target.value) }}
                                placeholder={allStrings?.PLACEHOLDER}
                                variant="outlined"
                                fullWidth
                                rows="3"
                                required
                            />
                            {errorMessage && (
                                <Typography sx={{ fontSize: 12, color: 'red' }}>{errorMessage}</Typography>
                            )}
                        </>
                    )}
                </DialogContentText>
                {allStrings.CANCEL && (
                    <Button variant="contained" sx={{ mr: 2 }} onClick={() => { handlecancel() }}>
                        {allStrings.CANCEL}
                    </Button>
                )}
                {allStrings.SUBMIT && (
                    <Button variant="contained" sx={{textTransform: "none", padding: !allStrings.CANCEL ? "5px 50px" : ""}} onClick={() => { handleSubmit(textFieldValue) }}>
                        {allStrings.SUBMIT}
                    </Button>
                )}
                <Box sx={{ display: "flex", justifyContent: "center", width: 1, mt: 1 }}>
                    {bottomLinkAction?.showBottomLink ? (
                        <Link onClick={bottomLinkAction.action} sx={{ cursor: "pointer" }}>{allStrings.BACK}</Link>
                    ) : ""}
                </Box>

            </DialogContent>
        </Dialog>
    )
}



